import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

if (import.meta.env.PROD) {
  // Reason: virtual:pwa-register pairs with `registerType: 'autoUpdate'` to wire
  // periodic update checks + skipWaiting/clients.claim swap semantics. Raw
  // navigator.serviceWorker.register would miss the auto-update hooks.
  import('virtual:pwa-register').then(({ registerSW }) => {
    registerSW({ immediate: true })
  })
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
